// Document dates use the application's existing UTC calendar convention.
export function currentCalendarDate(now: Date = new Date()): string {
  return now.toISOString().slice(0, 10);
}

export function calendarDayDifference(laterDate: string, earlierDate: string): number {
  return (Date.parse(`${laterDate}T00:00:00Z`) - Date.parse(`${earlierDate}T00:00:00Z`)) / 86400000;
}
